/**
 * Created by agengmaulana on 22/01/18.
 */
import React from 'react'

import {observer} from 'mobx-react';
import Prokontra_Comment_Report_Abuse from './../prokontra_comment_report_abuse/prokontra_comment_report_abuse'
import Prokontra_Comment_Share from './../prokontra_comment_share/prokontra_comment_share'
import Prokontra_Comment_Like_Button from './../prokontra_comment_like_button/prokontra_comment_like_button'
import styles from './../../assets/css/prokontra_comment.css'
import Comment_Empty_Data from './../comment_empty_data/comment_empty_data'
import 'moment/locale/id';

@observer
export default class Prokontra_comment_row extends React.Component {

    constructor(props) {
        super(props);

    }
    render(){
        const {dataStore,datastoresVerified} = this.props;

        if (dataStore.countCommentPro == 0 && dataStore.countCommentKon == 0 ){
            return <Comment_Empty_Data wording={dataStore.wording} wording2={dataStore.wording2} />;}
        // else if(dataStore.loadingRow == true){
        //     return <center><img src="https://cdn.detik.net.id/libs/font-newcomment/gears.svg"/></center>
        // }
        else if(dataStore.gagalload == true){
            return <Comment_Empty_Data wording="Terjadi kesalahan." wording2="Gagal memuat komentar" />
        }
        else

        return(
            <div>
                <div className={styles.pk_headtl}>
                    <div className={styles.pk_l}><a href="javascript:void(0);" onClick={()=>{this.sortList(0)}}><div>{dataStore.configKomentar.label_1}<span>{this.props.dataStore.countCommentPro}</span></div></a></div>
                    <div className={styles.pk_r}><a href="javascript:void(0);" onClick={()=>{this.sortList(1)}}><div>{dataStore.configKomentar.label_2}<span>{this.props.dataStore.countCommentKon}</span></div></a></div>
                    <div className="clearfix"></div>
                </div>
                <ul className={styles.tl_prokontra} >
                    {
                        dataStore.datastoresKomentar.map((data,index)=>{
                                let kiri = data.prokontra_label == 0 ? styles.ev_left  : styles.ev_right
                                let kiri2 = data.prokontra_label == 0 ? styles.lb_pro  : styles.lb_kont
                                let nama_label = data.prokontra_label == 0 ? dataStore.configKomentar.label_1  : dataStore.configKomentar.label_2
                                var moment = require('moment');
                                var convert = moment.unix(data.create_date).from();
                                let anchorhighlight = dataStore.anchor == data.id ? styles.cmt_anchor_prokontra : '';
                                let verified = "";
                                if (typeof datastoresVerified[data.author.uniqueid] !== 'undefined') {
                                    verified = datastoresVerified[data.author.uniqueid] ? <i className="dk_icon dk_icon-circle dk_check verified"></i> : ''
                                }
                                return(
                                    <li key={data.id} className={styles.event+' '+ kiri +' offset-first'+' '+anchorhighlight} id={'cmt'+data.id} >
                                        <div className={styles.tr_tla}></div>
                                        <div className={styles.head_pk}>
                                            <div className={styles.label_pk+' '+kiri2}><span></span>{nama_label}</div>
                                            <div className={styles.ratiobox+' '+styles.box_img+' '+styles.fl+' '+styles.mr10}>
                                                <div className={styles.img_con+' '+styles.lqd}>
                                                    <img src={data.author.photo} onError={(e)=>{e.target.src="https://connect.detik.com/assets/images/default.png"}} alt={data.author.name} title="#" className="" />
                                                </div>
                                            </div>
                                            <div className={styles.user}>
                                                {data.author.name} {verified}
                                                <div>{convert}</div>
                                            </div>
                                        </div>
                                        <div className={styles.clearfix}></div>
                                        <div className={styles.comment_pk}>
                                            {unescape(data.content)}
                                        </div>
                                        <div className={styles.like_sharepk}>
                                            <Prokontra_Comment_Like_Button id={data.id} isMobile="" parent_id="0" status_like={data.liker.length} like={data.like} dataStore={dataStore}/>
                                            &nbsp;
                                            <span>Bagikan :</span>
                                            &nbsp;
                                            <Prokontra_Comment_Share content={data.content} id={data.id} datFunction={dataStore} />
                                            <Prokontra_Comment_Report_Abuse id={data.id} isMobile="" status_lapor={data.reporter.length}  datFunction={dataStore} />

                                        </div>
                                    </li>
                                )
                            }

                        )
                    }
                    <div className="clearfix"></div>
                </ul>
            </div>
        )
    }
    sortList(event){
        this.props.dataStore.fetchDataKomentarProkontra(1,event)
    }
}


// WEBPACK FOOTER //
// ./static/src/component/prokontra_comment_row/prokontra_comment_row.js